import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { CaseRequestDto } from '../../models/dto/case-overview/case-request-dto.model';
import { CaseRequestStatusHistoryDto } from '../../models/dto/case-overview/case-request-status-history-dto.model';

@Component({
  selector: 'boi-case-request-status-history',
  templateUrl: './case-request-status-history.component.html',
  styleUrls: ['./case-request-status-history.component.scss']
})
export class CaseRequestStatusHistoryComponent {
  @Input() public caseRequest: CaseRequestDto;
  @Input() public showOnlyMostRecentHistoryStatus: boolean = false;

  public pipeSymbol = '|';

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;

  private statusCodeGroupIds = {
    IllustrationRequested: 1,
    IllustrationDownloadPending: 1,
    IllustrationDownloadFailed: 1,
    IllustrationManualProcessing: 1,

    SwitchRequested: 2,
    SwitchDownloadPending: 2,
    SwitchDownloadFailed: 2,
    RTRN2DAT: 2,

    MANOFFER: 3,
    FORPOST: 3
  };

  private areStatusCodesGroupped(statusCode1: string, statusCode2: string): boolean {
    const statusGroupId1 = this.statusCodeGroupIds[statusCode1];
    const statusGroupId2 = this.statusCodeGroupIds[statusCode2];

    if (statusCode1 === statusCode2) {
      return true;
    }

    if (!statusGroupId1 || !statusGroupId2) {
      return false;
    }

    return statusGroupId1 === statusGroupId2;
  }

  public getCaseRequestStatusHistoryList(): Array<CaseRequestStatusHistoryDto> {
    if (this.showOnlyMostRecentHistoryStatus) {
      const [mostRecentHistoryStatus] = this.caseRequest.CaseRequestStatusHistoryList.slice(0, 1);
      let lastRecentHistoryStatus = mostRecentHistoryStatus;

      if (mostRecentHistoryStatus) {
        for (const currentHistoryStatus of this.caseRequest.CaseRequestStatusHistoryList.slice(1)) {
          if (this.areStatusCodesGroupped(mostRecentHistoryStatus.StatusCode, currentHistoryStatus.StatusCode)) {
            lastRecentHistoryStatus = currentHistoryStatus;
          } else {
            break;
          }
        }
      }

      return lastRecentHistoryStatus ? [lastRecentHistoryStatus] : [];
    }

    return this.caseRequest.CaseRequestStatusHistoryList;
  }
}
